import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import {SignalRHub} from "../hubs/signalr-hub";
import HubServiceName, {HubService} from "../hubs/hub.service";

export interface TopDefectsHub extends SignalRHub {
  joinGroup(shopId: string): Promise<any>;
  leaveGroup(shopId: string): Promise<any>;
}

export interface TopDefectsHubCreator {
  createTopDefectsHub(shopId: string,
                      onAdd: (defect: apsViewModels.TopDefectEvent) => void,
                      onRemove: (defect: apsViewModels.TopDefectEvent) => void): TopDefectsHub;
}

class TopDefectsHubCreatorImpl implements TopDefectsHubCreator {

  private hubService: HubService;

  constructor(hubService: HubService) {
    this.hubService = hubService;
  }

  createTopDefectsHub(shopId: string,
                      onAdd: (defect: apsViewModels.TopDefectEvent) => void,
                      onRemove: (defect: apsViewModels.TopDefectEvent) => void): TopDefectsHub {
    return this.hubService.createHub<TopDefectsHub>('topDefects', {
      listeners: {
        topDefectAdded: d => {
          if (d.shopId !== shopId) {
            return;
          }
          onAdd(d);
        },
        topDefectRemoved: d => {
          if (d.shopId !== shopId) {
            return;
          }
          onRemove(d);
        }
      },
      allowMultipleListeners: true,
      methods: ['leaveGroup', 'joinGroup'],
      postConnect: (hub: TopDefectsHub) => {
        hub.invokeWithRetry(() => hub.joinGroup(shopId));
      }
    });
  }
}

export default angular.module('aps.hubs.topDefects', [HubServiceName])
  .service('topDefectsHubCreator', TopDefectsHubCreatorImpl)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/reports/topDefects.hub.ts